const BaseModule = require('../../../../90_utils/base/BaseModule');

class StatBlock extends BaseModule {

	constructor(el, params) {

		super(el);
	}

	// basemodule methods

	_domReady(){

	}

	_addListeners(){ }
	_removeListeners(){ }

	//

	_show(){

		// let $statdata = this.$el.find('.stat-text--numeric');
		// let text = $statdata.text().replace(/,/g, "");
		// let data = parseInt(text);

		// if( !isNaN(data) ){
		// 	console.log(data);
		// }
	}
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }

}

module.exports = StatBlock;
